var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools01-abtest"},[_c('el-row',[_c('el-col',[_c('h2',[_vm._v("ABテスト")])])],1),_c('AbTestList',{attrs:{"toolId":_vm.toolId,"pageId":_vm.pageId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }